var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',_vm._l((_vm.statusLista),function(status,index){return _c('b-col',{key:status},[_c('app-box',{attrs:{"titulo":status,"corBox":_vm.corBox(status),"corTexto":_vm.corTexto(status)}},[_vm._v(_vm._s(_vm._f("currency")(_vm.totaisLista[index])))])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }